import { render, staticRenderFns } from "./LeaveRequestApproval.vue?vue&type=template&id=158faf37&"
import script from "./LeaveRequestApproval.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports